import { Controller } from '@cherrypulp/trunk';
// import AOS from 'aos';

export default class HomeController extends Controller {
    /**
     * Condition to execute controller.
     * @return {boolean}
     */
    isActive() {
        return document.body.classList.contains('template-home');
    }

    /**
     * Mounted.
     */
    mounted() {
        // AOS.init();

        this.handleSmoothScroll();
        this.handleOrderBtn();
    }

    handleSmoothScroll()
    {
        Array.from( document.querySelectorAll('.header-nav .nav-list a') ).map( el => {
            const target = document.querySelector( el.getAttribute('data-target') );

            if ( target ) {
                el.addEventListener( 'click', e => {
                    e.preventDefault();

                    target.scrollIntoView( { behavior: 'smooth' } );
                } );
            }
        } );

        const btn = document.querySelector('.burger-button');
        const responsive = document.querySelector('.responsive-menu');

        Array.from( document.querySelectorAll('.responsive-menu .nav-list a') ).map( el => {
            const target = document.querySelector( el.getAttribute('data-target') );

            if ( target ) {
                el.addEventListener( 'click', e => {
                    e.preventDefault();

                    if ( btn ) {
                        document.body.classList.remove('responsive-menu-opened');
                        btn.classList.remove('opened');
                        responsive.classList.remove('opened');
                    }

                    target.scrollIntoView( { behavior: 'smooth' } );
                } );
            }
        } );

        Array.from( document.querySelectorAll('.section--hero button') ).map( el => {
            const target = document.querySelector( el.getAttribute('data-target') );

            if ( target ) {
                el.addEventListener( 'click', e => {
                    e.preventDefault();

                    target.scrollIntoView( { behavior: 'smooth' } );
                } );
            }
        } );
    }

    handleOrderBtn()
    {
        const wrapper = document.querySelector( '.mobile-order-button' );

        if ( wrapper !== undefined ) {
            const header = document.querySelector('.section--hero');

            const posHandler = () => {
                if ( window.innerWidth <= 768 ) {
                    const header_bottom = header.getBoundingClientRect().height;
                    const scrollY = window.scrollY + window.innerHeight;

                    if ( scrollY >= header_bottom - 24 ) {
                        wrapper.classList.add('show');
                    } else {
                        wrapper.classList.remove('show');
                    }
                }
            };

            window.addEventListener('scroll', posHandler );
            posHandler();
        }
    }
}
